import { render, staticRenderFns } from "./movimento-form.vue?vue&type=template&id=23c9d451"
import script from "./movimento-form.vue?vue&type=script&lang=js"
export * from "./movimento-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports